import { render, staticRenderFns } from "./DentalImplantConsentForm.vue?vue&type=template&id=ff321f36&scoped=true"
import script from "./DentalImplantConsentForm.vue?vue&type=script&lang=js"
export * from "./DentalImplantConsentForm.vue?vue&type=script&lang=js"
import style0 from "./DentalImplantConsentForm.vue?vue&type=style&index=0&id=ff321f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff321f36",
  null
  
)

export default component.exports